(function () {
  function videosFor(button) {
    return (button.getAttribute('aria-controls') || '')
      .split(/\s+/)
      .filter(Boolean)
      .map(function (id) {
        return document.getElementById(id);
      })
      .filter(Boolean);
  }

  function setPlaying(button, playing) {
    var pauseLabel = button.getAttribute('data-label-pause') || 'Pause video';
    var playLabel = button.getAttribute('data-label-play') || 'Play video';
    button.setAttribute('aria-label', playing ? pauseLabel : playLabel);
    button.classList.toggle('is-paused', !playing);

    var pauseIcon = button.querySelector('.video-pause-control__icon--pause');
    var playIcon = button.querySelector('.video-pause-control__icon--play');
    if (pauseIcon) pauseIcon.hidden = !playing;
    if (playIcon) playIcon.hidden = playing;
  }

  function syncButton(button) {
    var videos = videosFor(button);
    setPlaying(
      button,
      videos.some(function (video) {
        return !video.paused;
      })
    );
  }

  function initVideoPauseControl(button) {
    if (button.dataset.videoPauseReady === 'true') return;

    var videos = videosFor(button);
    if (!videos.length) return;

    button.dataset.videoPauseReady = 'true';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function pauseAll() {
      videos.forEach(function (video) {
        video.pause();
      });
    }

    function playAll() {
      videos.forEach(function (video) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      });
    }

    if (reduceMotion.matches) pauseAll();

    button.addEventListener('click', function () {
      var playing = videos.some(function (video) {
        return !video.paused;
      });
      if (playing) {
        pauseAll();
      } else {
        playAll();
      }
      syncButton(button);
    });

    videos.forEach(function (video) {
      video.addEventListener('play', function () {
        syncButton(button);
      });
      video.addEventListener('pause', function () {
        syncButton(button);
      });
    });

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function (event) {
        if (event.matches) pauseAll();
      });
    }

    syncButton(button);
  }

  function queryAll(root, selector) {
    var scope = root || document;
    var nodes = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) {
      nodes.push(scope);
    }
    scope.querySelectorAll(selector).forEach(function (node) {
      nodes.push(node);
    });
    return nodes;
  }

  function initVideoPauseControls(root) {
    queryAll(root, '[data-video-pause-control]').forEach(initVideoPauseControl);
  }

  function syncInstagramLinkNames(root) {
    queryAll(root, 'a[href*="instagram.com"][aria-label]').forEach(function (link) {
      var visible = (link.textContent || '').replace(/\s+/g, ' ').trim();
      var name = (link.getAttribute('aria-label') || '').trim();
      if (!visible || !name) return;
      if (name.toLowerCase().indexOf(visible.toLowerCase()) !== -1) return;
      link.setAttribute('aria-label', name + ' ' + visible);
    });
  }

  function applyBadgeRole(badge) {
    if (!badge.getAttribute('role')) {
      badge.setAttribute('role', 'img');
    }
  }

  function nameChatBadges(root) {
    queryAll(root, '.activator__indicator[aria-label]').forEach(applyBadgeRole);

    queryAll(document, 'shopify-chat').forEach(function (host) {
      if (!host.shadowRoot) return;
      observeRoot(host.shadowRoot);
      host.shadowRoot.querySelectorAll('.activator__indicator[aria-label]').forEach(applyBadgeRole);
    });
  }

  function siblingHeadingText(image) {
    var parent = image.parentElement;
    if (!parent) return '';

    var heading = parent.querySelector('h1, h2, h3, h4, h5, h6, [class*="title"], [class*="heading"]');
    if (heading && heading !== image) {
      return (heading.textContent || '').replace(/\s+/g, ' ').trim();
    }

    var sibling = parent.previousElementSibling || parent.nextElementSibling;
    if (sibling) {
      var siblingHeading = sibling.querySelector('h1, h2, h3, h4, h5, h6');
      if (siblingHeading) {
        return (siblingHeading.textContent || '').replace(/\s+/g, ' ').trim();
      }
    }

    return '';
  }

  function nameRivoStepImages(root) {
    queryAll(root, 'img[src*="Rivo_Step_"]').forEach(function (image) {
      if (image.hasAttribute('alt') && image.getAttribute('alt') !== null && image.getAttribute('alt') !== '') {
        return;
      }

      var parent = image.parentElement;
      var parentText = parent
        ? (parent.textContent || '').replace(/\s+/g, ' ').trim()
        : '';

      if (parentText) {
        image.setAttribute('alt', '');
        return;
      }

      var headingText = siblingHeadingText(image);
      image.setAttribute('alt', headingText);
    });
  }

  function init(root) {
    initVideoPauseControls(root);
    syncInstagramLinkNames(root);
    nameChatBadges(root);
    nameRivoStepImages(root);
  }

  var observerOptions = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label'],
  };

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target && mutation.target.nodeType === 1) {
        init(mutation.target);
      }
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        init(node);
      });
    });
  });

  function observeRoot(root) {
    if (!root || root.__a11yObserved) return;
    root.__a11yObserved = true;
    observer.observe(root, observerOptions);
  }

  observer.observe(document.documentElement, observerOptions);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.addEventListener('load', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
